import { BaseController } from '../../../common/base/controller';
import _ from 'lodash';

export class ProgressBarController extends BaseController {
  constructor(controllerService, $transitions) {
    'ngInject';
    super({ controllerService, $transitions });
  }

  get progressItemStyle() {
    return {
      width: 100 / this.states.length + '%',
    };
  }

  get progressBarStyle() {
    const margin = (100 / this.states.length) / 2;
    return {
      left: margin + '%',
      right: margin + '%',
      width: 100 - margin * 2 + '%',
    };
  }

  get progressBarSliderStyle() {
    const index = this.currentStateIndex;
    return {
      // calculate current length of progress bar
      width: this.getProgressbarWidth(index, this.states.length, 100) + '%',
    };
  }

  get isStartPage() {
    return this.currentState && this.currentState.name === 'app.start';
  }

  $onInit() {
    this.$transitions.onSuccess({}, this.onStateChange.bind(this));
    this.onStateChange();
  }

  onStateChange() {
    this.setStateIndex();
  }

  setStateIndex() {
    this.currentStateIndex = _.findIndex(this.states, {
      stateName: this.currentState.name,
    });
    this.showProgressBar = this.currentStateIndex > -1;

    // Store/update latest (highest) transitioned state
    this.lastStateIndex = this.appCache.get('lastStateIndex') || -1;
    if (this.lastStateIndex < this.currentStateIndex) {
      this.appCache.set('lastStateIndex', this.currentStateIndex);
    }
  }

  getStateStyle(state = this.currentState, index = this.currentStateIndex) {
    const { currentStateIndex, lastStateIndex } = this;

    state.active = state.stateName === this.$state.current.name;
    state.completed = index < Math.max(currentStateIndex, lastStateIndex);
    state.disabled = !(
      state.active ||
      state.completed ||
      index <= lastStateIndex
    );
    state.style = this.progressItemStyle;
    state.type = state.disabled ? 'text' : 'link';
    state.isLink = state.type === 'link';
    state.status = state.isLink ? '' : 'disabled';

    return state.style;
  }

  getProgressbarWidth(currentStep, totalSteps, totalWidth) {
    if (currentStep > totalSteps) {
      currentStep = totalSteps;
    }
    // The progress should be calculated by the completed steps:
    // Instead of dividing by the total steps, we divide by totalSteps - 1,
    // because each step represents a portion of the completed progress.
    const width = ((currentStep) / (totalSteps - 1)) * totalWidth;
    return width;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/ui/progressBar/progressBar.controller.js